// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_MarcarAgenteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /chamados/marcar-agente
 *
 * `agente` vazio LIMPA a marca; qualquer outro valor tem de ser um pedido de
 * `ChamadoAgente`. Não há campo de autor: quem marcou é o JWT.
 */
import { registerContract } from './validate'

export interface Chamados_MarcarAgenteInput {
chamado_id: number
agente?: string
}

registerContract('Chamados_MarcarAgenteInput', {
  chamado_id: { type: 'number',  required: true },
  agente:     { type: 'string',  required: false },
})
